module.exports.message = {
  BROWSER_UPDATE_REQUIRED:
    'This feature requires a browser update. Please contact your IT department.',

  COMPLETED_AUDIT_SUCCESSFULLY:
    'Thank you for completing your QHA audit. Your coordinator will shortly receive your completed submission.',

  FAILED_TO_SET_ACTIVATION_STATUS:
    'Sorry we had a problem setting the activation status. Please try again',

  FAILED_TO_EDIT_ITEM: 'Sorry. There was an error editing that item',

  FAILED_TO_PROCESS_REQUEST:
    'Sorry we had a problem processing your request. Please try again',

  FAILED_TO_SAVE: 'Sorry we had a problem saving. Please try again',

  FAILED_TO_SAVE_ASSESSMENT:
    'There was an error saving your assessment. Please try again',

  FAILED_TO_SAVE_AUDIT:
    'There was an error saving your audit, please refresh the page and try again',

  FAILED_TO_SAVE_ITEM: 'Sorry. There was an error saving that item',
  FAILED_EMAIL_VALIDATION: 'A valid email is required',

  FAILED_TO_UPLOAD_PLANS: err =>
    `Sorry, there was a problem uploading your plans. If the problem persists please contact support (msg: ${err}`,

  FILL_OUT_ALL_FIELDS: 'Please make sure all fields are entered.',
  MUST_GRADE_SEN_HEALTH:
    'You must grade at least one SEN health needs section.',
  NO_PLANS_ASSIGNED: 'There are no plans assigned',

  PASSWORD_RESET_LINK_SENT:
    'We have sent you a password reset link. Please check your email.',

  PLAN_ALREADY_ASSIGNED: name =>
    `A plan with this ID has already been assigned to ${name}. Please try to assign another plan`,

  PLEASE_COMPLETE_MANDATORY_FIELDS: invalidEntries =>
    'Please ensure you have completed all the mandatory fields. Only fields not mandatory are Team Region and SEN Case Officer. Check rows ' +
    invalidEntries.map(({ row }) => row).join(', '),

  PLEASE_UPLOAD_PLANS: 'Please upload first.',
  SUCCESSFULLY_ADDED_USER: 'User added.',
  SUCCESSFULLY_UPLOADED_PLANS: 'Plans uploaded.',

  UNSAVED_CHANGES: dirtySections =>
    `You have made changes in section ${dirtySections}. Please click 'Next Theme' in section ${dirtySections} to save these changes.`,

  UNSAVED_NEXT_STEPS: "You haven't finished making your changes.",

  USE_THIS_EMAIL: email =>
    `The email the user needs to use for sign in is ${email}.`
}
